import { Editor } from '@tinymce/tinymce-react'
import tinymce from 'tinymce/tinymce'

// Patch TinyMCE's EditorManager to wrap getBody() on each editor instance.
// This prevents "Cannot read properties of null (reading 'childNodes')" errors
// that occur when TinyMCE's UndoManager calls editor.getBody() during the
// 'init' event, but the body hasn't been fully initialized yet (especially
// for inline editors). By returning a dummy element instead of null, the
// UndoManager safely creates an empty undo level instead of crashing.
const originalCreateEditor = tinymce.EditorManager.createEditor
tinymce.EditorManager.createEditor = function(id, settings) {
  const editor = originalCreateEditor.call(this, id, settings)

  if (editor && typeof editor.getBody === 'function') {
    const originalGetBody = editor.getBody.bind(editor)
    editor.getBody = function() {
      const body = originalGetBody()
      if (body === null || body === undefined) {
        // Return an empty div with childNodes property to prevent crashes
        // in TinyMCE's internal code (UndoManager, Fragments.read, etc.)
        return document.createElement('div')
      }
      return body
    }
  }

  return editor
}

// ok, black magic time
// tinymce-react runs setContent after init, which we don't need
// because we set the content in the textarea
// so we need the first execution of setContent to do nothing
// or it will override the content from the textarea
Editor.prototype.originalInitEditor = Editor.prototype.initEditor
Editor.prototype.initEditor = function(initEvent, editor) {
  // Guard against editor being destroyed during async initialization.
  if (!editor || editor.removed) {
    return
  }

  if (this.inline) {
    return Editor.prototype.originalInitEditor.apply(this, [initEvent, editor])
  }
  editor.originalSetContent = editor.setContent
  editor.setContent = function() {
    // First run of this function `editor.setContent` is a noop, the only thing
    // it does is reset setContent back to the original definition so that
    // subsequent runs work normally.
    editor.setContent = editor.originalSetContent
  }
  return Editor.prototype.originalInitEditor.apply(this, [initEvent, editor])
}

// This is a monkey patch to put the initialValue (if present)
// in the textarea, so it renders instantly
Editor.prototype.renderIframe = function() {
  var _this = this
  var value =
    typeof this.props.initialValue === 'string' ? this.props.initialValue : ''
  return React.createElement('textarea', {
    ref: function(elm) {
      return (_this.element = elm)
    },
    style: { visibility: 'hidden' },
    id: this.id,
    defaultValue: value,
  })
}

module.exports = {
  Editor,
}
